import { jsGenerator, Workspace } from '@cna-br/astro-code';
import compareBlocks from './material/section/compareBlocks';
import { BlockCodeActivityElement } from '@/models/_deprecated/ActivityElement';
import {
  ActivityMode,
  AttemptContent,
  BlockCodeActivityProgress,
} from '@/models/ActivityProgress';
import { ActivityTypeEnum } from '@/models/_deprecated/ActivityElement';

export const jsFixGenerator = (workspace: Workspace) => {
  const code = jsGenerator.workspaceToCode(workspace);
  return addFunctionScope(code.replace('function main() {', ''));
};

export const addFunctionScope = (code: string) => {
  return `(function(){${code}})();`;
};

export const generateBlockPayload = (original: object, changes?: object) => {
  if (!changes) return undefined;
  const isEqual = compareBlocks(original, changes);
  if (isEqual) return undefined;
  return changes;
};

type GetWorkspaceArgs = {
  activity?: BlockCodeActivityElement;
  blockProgress?: BlockCodeActivityProgress;
  attemptElement?: AttemptContent;
  mode: ActivityMode;
};

export const getWorkspace = ({
  activity,
  blockProgress,
  attemptElement,
  mode,
}: GetWorkspaceArgs) => {
  if (mode === 'review' && attemptElement?.type === ActivityTypeEnum.BLOCK) {
    return attemptElement.progress.answerWorkspace || undefined;
  }

  if (mode === 'answerkey' && attemptElement?.type === ActivityTypeEnum.BLOCK) {
    return attemptElement.progress.answerWorkspace || undefined;
  }

  if (blockProgress?.answerWorkspace) {
    return blockProgress?.answerWorkspace;
  }

  if (activity?.initialWorkspace) {
    return activity.initialWorkspace;
  }

  return undefined;
};
